import { Icon } from "@iconify/react";
import { CSSProperties, memo } from "react";
import { ThemeStyle } from "../../hooks/useTheme";

type ContainerButtonProps = {
  onPress: () => void;
  iconName?: string;
  iconSize?: number;
  theme: ThemeStyle;
  disabled?: boolean;
  containerStyles?: CSSProperties;
};

// Used as a button with a background container
export const ContainerButton = memo(function ContainerButtonFn(
  props: ContainerButtonProps
) {
  const { onPress, iconName, iconSize, theme, containerStyles, disabled } =
    props;

  const styles = {
    backButton: {
      border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
      borderRadius: 12,
      padding: 10,
      backgroundColor: theme.NewPrimaryBG.backgroundColor,
      cursor: "pointer",
      ...containerStyles,
    },
  };

  return (
    <div
      className="Centering"
      style={{
        ...styles.backButton,
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? "none" : "all",
      }}
      onClick={onPress}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.opacity = "0.7";
      }}
      onMouseLeave={(e) => {
        if (!disabled) e.currentTarget.style.opacity = "1";
      }}
    >
      <Icon
        icon={iconName ?? "ion:arrow-back"}
        height={iconSize ?? 24}
        style={{ color: theme.PrimaryText.color }}
      />
    </div>
  );
});
